import React from 'react';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import LogoCircleIcon from '../../../../shared/images/idnty-logo-circle.svg';

import AppDownloadButtons from './AppDownloadButtons';

const CHECKMARK_COLOR = '#22C55E';

const BodyText = styled('p')`
  color: ${(props) => props.textColor || '#ffffff'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  max-width: ${(props) => props.maxWidth || '600px'};
  text-align: center;
  width: 100%;
`;

const BottomTextContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 420px;
  width: 100%;
`;

const CheckmarkContainer = styled('div')`
  align-items: center;
  background: transparent;
  border: 4px solid ${CHECKMARK_COLOR};
  border-radius: 50%;
  display: flex;
  height: 80px;
  justify-content: center;
  width: 80px;
`;

const Divider = styled('div')`
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;
`;

const DividerIcon = styled('img')`
  flex-shrink: 0;
  height: 19px;
  width: 19px;
`;

const DividerLine = styled('hr')`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  flex: 1;
  margin: 0;
`;

const DownloadLabel = styled('div')`
  color: #ffffff;
  font-family: 'Roboto Mono', 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  height: auto;
  letter-spacing: 3px;
  line-height: 1.5;
  max-width: 340px;
  text-align: center;
  text-transform: uppercase;
`;

const DownloadSection = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 480px;
  padding: 0 24px;
  width: 100%;
`;

const YoureInText = styled('h1')`
  color: #ffffff;
  font-family: 'Roboto Mono', 'Nunito Sans', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.5;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
`;

const IdntyDownloadView = ({ showSuccessText }) => (
  <Wrapper>
    <CheckmarkContainer>
      <IcomoonReact iconSet={iconSet} icon='checkmark' size={32} color={CHECKMARK_COLOR} />
    </CheckmarkContainer>
    <YoureInText>You&apos;re In!</YoureInText>
    {showSuccessText && (
      <BodyText maxWidth='600px' textColor='#ffffff'>
        Your account has been successfully created.
        Please download the TeamBuildr Training app to get started.
      </BodyText>
    )}
    <Divider>
      <DividerLine />
      <DividerIcon src={LogoCircleIcon} alt='' />
      <DividerLine />
    </Divider>
    <DownloadSection>
      <BottomTextContainer>
        <DownloadLabel>Download the App</DownloadLabel>
        <BodyText maxWidth='420px' textColor='#787878'>
          Unlock instant access to world-class training programs from elite coaches.
        </BodyText>
      </BottomTextContainer>
      <AppDownloadButtons />
    </DownloadSection>
  </Wrapper>
);

IdntyDownloadView.propTypes = {
  showSuccessText: PropTypes.bool,
};

IdntyDownloadView.defaultProps = {
  showSuccessText: true,
};

export default IdntyDownloadView;
